module.exports = __webpack_public_path__ + "img/bg_top.d562e371.png";